(function($){
  var homeNewsletter = {
    init: function(){
      if ($('.home-contact').length){
        homeNewsletter.inithomeNewsletter();
      }
    },
    inithomeNewsletter: function(){
      var $homeForm = $('.home-contact form');
      var $realBtn = $homeForm.find('input[type="button"]');
      var $email = $homeForm.find('input[type="email"]');
      var $fakeBtn = '<button class="btn-form" type="button"><svg role="img" class="icon icon-arrow-right "><use xlink:href="/themes/ovmap/assets/images/icons.sprite.svg#icon-arrow-right"></use></svg></button>';

      $email.after($fakeBtn);

      $('.btn-form').on('click', function() {
        $($realBtn).click();
      });

    }
  };
  $(document).on( 'nfFormReady', function() {
    homeNewsletter.init();
  });
})(jQuery);
